'use client';

import * as React from 'react';
import Link from 'next/link';
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  Container,
  Typography,
  Menu,
  MenuItem,
  IconButton,
} from '@mui/material';
import { Analytics, AccountCircle } from '@mui/icons-material';
import { useAuth } from '@/contexts/AuthContext';
import { useRouter } from 'next/navigation';

// Navegación única
const navigation = [
  { name: 'Inicio', href: '/' },
  { name: 'Proyectos', href: '/proyectos' },
  { name: 'Servicios', href: '/servicios' },
  { name: 'Miembros', href: '/miembros' },
];

export default function AppBarComponent() {
  const { user, isAuthenticated, loading, logout } = useAuth();
  const router = useRouter();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    logout();
    handleClose();
    router.push('/');
  };

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between', pt: 1 }}>
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Analytics sx={{ mr: 1, color: '#fff' }} />
            <Typography
              variant="h6"
              noWrap
              component={Link}
              href="/"
              sx={{ fontWeight: 700, color: '#fff', textDecoration: 'none' }}
            >
              Vixia System
            </Typography>
          </Box>

          {/* Navigation - Desktop */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
            }}
          >
            {navigation.map(item => (
              <Button
                key={item.name}
                component={Link}
                href={item.href}
                sx={{
                  mx: 1,
                  color: '#fff',
                  fontWeight: 600,
                  '&:hover': { backgroundColor: 'rgba(30, 64, 175, 0.04)' },
                }}
              >
                {item.name}
              </Button>
            ))}
          </Box>

          {/* Auth Section */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {loading ? null : isAuthenticated ? (
              <>
                <Typography
                  variant="body2"
                  sx={{ mr: 1, display: { xs: 'none', sm: 'block' } }}
                >
                  Hola, {user?.username}
                </Typography>
                <IconButton
                  size="large"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/* <MenuItem onClick={handleClose}>Perfil</MenuItem> */}
                  <MenuItem component={Link} href="/profile" onClick={handleClose}>Perfil</MenuItem>
                  <MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  component={Link}
                  href="/login"
                  color="inherit"
                  sx={{ fontWeight: 600 }}
                >
                  Iniciar Sesión
                </Button>
                <Button
                  component={Link}
                  href="/register"
                  variant="contained"
                  sx={{ fontWeight: 600 }}
                >
                  Registrarse
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
